export function siteNav() {
    const navButton = document.querySelector('[data-nav-trigger]');
    const body = document.body;
    const header = document.querySelector('.site__header');

    if (navButton) {
        navButton.addEventListener('click', function() {
            let expanded = this.getAttribute('aria-expanded') === 'true' || false;
            let menu = this.parentElement;
            
            this.setAttribute('aria-expanded', !expanded);
            this.innerText = expanded ? 'Menu' : 'Close';
            
            header.classList.toggle('active');
            body.classList.toggle('no-scroll');
        });
    }
}
